import { UploadViewComponent } from '../../views/upload-view/upload-view.component';
import { MenuEntryWithCounter } from './menu-entry-with-counter';

export class UploadsMenuEntry extends MenuEntryWithCounter {
  public constructor() {
    super('Uploads', 'cloud-upload', UploadViewComponent, 400);
  }
}
